// import { useEffect } from 'react';

// import { useRouter } from 'next/router';

import NewselaGlobalLayout from "@/base";
import Footer from "@/base/Footer";
import RootProviders from "@/base/RootProviders";
import ChallengesLayout from "@/challenges/ChallengesLayout";
import ChallengeWrapperView from "@/challenges/ChallengeWrapperView";
// import useHasContentSettings from '@/challenges/utils/useHasContentSettings';
import withChallengesPrivileges from "@/challenges/withChallengesPrivileges";
import getUserProperties from "@/users/getUserProperties";
import useUser from "@/users/useUser";

const ChallengesPage = () => {
  const { data: user } = useUser();
  const { isTeacher } = getUserProperties(user);
  // const router = useRouter();
  // const { data: hasContentSettings } = useHasContentSettings;

  // useEffect(() => {
  //   if (hasContentSettings) {
  //     const consetGroups = hasContentSettings.conset_groups;
  //     const hideItems = hasContentSettings.hide_items;
  //     const hideSets = hasContentSettings.hide_sets;
  //     const markerRules = hasContentSettings.marker_rules;
  //     if (consetGroups?.length || hideItems?.length || hideSets?.length || markerRules?.length) {
  //       router.push('/home/');
  //     }
  //   }
  // }, [hasContentSettings]);

  return (
    <NewselaGlobalLayout
      mainContents={
        <ChallengesLayout>
          <ChallengeWrapperView
            isTeacher={isTeacher}
            setNoData={(data) => {
              return data;
            }}
          />
          <Footer />
        </ChallengesLayout>
      }
    />
  );
};

export async function getServerSideProps(ctx) {
  const RootProvidersInitialProps = await RootProviders.__getInitialProps({
    ctx,
  });
  return {
    props: {
      [RootProviders.InitialPropsName]: RootProvidersInitialProps,
    },
  };
}

export default withChallengesPrivileges(ChallengesPage);
